<template>
  <div class="container-custom">
    <Breadscrumbs
      :links="[
        { name: 'Account List', to: { path: '/account-list' } },
        { name: 'Account Edit', to: { path: '/account-list/account-edit' } },
      ]"
    ></Breadscrumbs>
    <div class="page-actions">
      <h2>編輯Account</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">取消</button>
      <button class="btn btn-primary" @click="saveHandler">儲存</button>
    </div>
    <!-- block1 -->
    <div class="block">
      <div class="form-item py-5 d-flex">
        <div class="w-240px mr-5">
          <h4>部門</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">{{ departmentName }}</div>
      </div>
      <div class="form-item py-5 d-flex">
        <div class="w-240px mr-5">
          <h4>帳號</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">{{ accountName }}</div>
      </div>
      <div class="form-item py-5 d-flex">
        <div class="w-240px mr-5">
          <h4>建立日期</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">{{ createDate }}</div>
      </div>
      <div class="form-item py-5 d-flex">
        <div class="w-240px mr-5">
          <h4>啟用/停用</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <FormSwitch
            v-model="isActive"
            :showText="{ open: '啟用', close: '停用' }"
          ></FormSwitch>
        </div>
      </div>
      <div class="form-item py-5 d-flex">
        <div class="w-240px mr-5">
          <h4>啟用/停用</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <button class="btn btn-danger w-80px" @click="deleteHandler">
            刪除
          </button>
        </div>
      </div>
    </div>
    <!-- block2 -->
    <div class="mt-5 table block mb-5">
      <div class="form-item d-flex py-5">
        <h5 class="v-icon w-44px"></h5>
        <h5 class="col-main-category">大綱</h5>
        <h5 class="col-sub-category">次類</h5>
        <h5 class="col-icon ml-auto text-center">勾選</h5>
      </div>
      <template v-for="item in categoryOptions">
        <!-- if no subcategory -->
        <div
          v-if="item.subCategories.length === 0"
          :key="`${item.mainCategory}-noCollapseBtn`"
        >
          <div class="form-item d-flex h-60px align-center">
            <div class="h5 col-icon"></div>
            <div class="col-main-category h5">{{ item.mainCategory }}</div>
            <div class="col-icon ml-auto d-flex justify-center align-center">
              <v-checkbox
                class="w-24px h-24px mb-1"
                @click.stop=""
                v-model="
                  selectedCategory[item.mainCategory].isMainCategorySelected
                "
              ></v-checkbox>
            </div>
          </div>
        </div>

        <!-- if has subcategory -->
        <TableCollapse
          :key="item.mainCategory"
          v-if="item.subCategories.length > 0"
        >
          <!-- row 1 -->
          <template v-slot:head="slotProps">
            <div class="form-item d-flex h-60px align-center">
              <div class="h5 col-icon">
                <v-icon color="ink-01-emphasis" v-if="!slotProps.isBodyShow"
                  >unfold_more</v-icon
                >
                <v-icon color="ink-01-emphasis" v-if="slotProps.isBodyShow"
                  >unfold_less</v-icon
                >
              </div>
              <div class="col-main-category h5">{{ item.mainCategory }}</div>
              <div class="col-icon ml-auto d-flex justify-center align-center">
                <v-checkbox
                  class="w-24px h-24px mb-1"
                  @click.stop="toggleAllSubcategoriesStatus(item.mainCategory)"
                  v-model="
                    selectedCategory[item.mainCategory].isMainCategorySelected
                  "
                  :indeterminate="
                    isAllSubCategoriesSomeSelected(item.mainCategory)
                  "
                ></v-checkbox>
              </div>
            </div>
          </template>
          <!-- row 2 -->
          <template v-slot:body>
            <div
              class="form-item d-flex h-60px align-center h5"
              v-for="(subitem, j) in item.subCategories"
              :key="`${item.mainCategory}-subitem-${j}`"
            >
              <div class="col-icon"></div>
              <div class="col-main-category"></div>
              <div class="col-sub-category">{{ subitem }}</div>
              <div class="col-icon ml-auto d-flex justify-center align-center">
                <v-checkbox
                  class="w-24px h-24px mb-1"
                  @click.stop=""
                  :value="subitem"
                  v-model="selectedCategory[item.mainCategory].subCategories"
                ></v-checkbox>
              </div>
            </div>
          </template>
        </TableCollapse>
      </template>
    </div>
  </div>
</template>

<script>
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import FormSwitch from '@/components/FormSwitch.vue';
import TableCollapse from '@/components/TableCollapse.vue';

export default {
  components: {
    Breadscrumbs,
    FormSwitch,
    TableCollapse,
  },
  data: () => ({
    // block1
    departmentName: '快樂部門',
    accountName: 'Happy_Wasa',
    createDate: '2020.08.08 11:13:09',
    isActive: true,
    // block2
    categoryOptions: [
      {
        mainCategory: 'About Us',
        subCategories: [],
      },
      {
        mainCategory: 'Page Management',
        subCategories: ['subCategory1', 'subCategory2'],
      },
      {
        mainCategory: 'Product Management',
        subCategories: [
          'Category',
          'SubCategory',
          'Product',
          'Product Download',
        ],
      },
      {
        mainCategory: 'Award',
        subCategories: [],
      },
      {
        mainCategory: 'News Center',
        subCategories: [],
      },
      {
        mainCategory: 'Customer Management',
        subCategories: ['subCategory1', 'subCategory2'],
      },
      {
        mainCategory: 'Service & Support',
        subCategories: [],
      },
      {
        mainCategory: 'Where to buy',
        subCategories: [],
      },
      {
        mainCategory: 'Investor Relations',
        subCategories: ['subCategory1', 'subCategory2'],
      },
      {
        mainCategory: 'Human Resource',
        subCategories: [],
      },
      {
        mainCategory: 'eNewsletter',
        subCategories: [],
      },
      {
        mainCategory: 'Material Gallery',
        subCategories: [],
      },
      {
        mainCategory: 'Account Management',
        subCategories: ['subCategory1', 'subCategory2'],
      },
    ],
    selectedCategory: {
      'About Us': {
        mainCategory: 'About Us',
        subCategories: [],
        isMainCategorySelected: true,
      },
      'Page Management': {
        mainCategory: 'Page Management',
        subCategories: [],
        isMainCategorySelected: false,
      },
      'Product Management': {
        mainCategory: 'Product Management',
        subCategories: [],
        isMainCategorySelected: false,
      },
      Award: {
        mainCategory: 'Award',
        subCategories: [],
        isMainCategorySelected: false,
      },
      'News Center': {
        mainCategory: 'News Center',
        subCategories: [],
        isMainCategorySelected: false,
      },
      'Customer Management': {
        mainCategory: 'Customer Management',
        subCategories: [],
        isMainCategorySelected: false,
      },
      'Service & Support': {
        mainCategory: 'Service & Support',
        subCategories: [],
        isMainCategorySelected: false,
      },
      'Where to buy': {
        mainCategory: 'Where to buy',
        subCategories: [],
        isMainCategorySelected: false,
      },
      'Investor Relations': {
        mainCategory: 'Investor Relations',
        subCategories: [],
        isMainCategorySelected: false,
      },
      'Human Resource': {
        mainCategory: 'Human Resource',
        subCategories: [],
        isMainCategorySelected: false,
      },
      eNewsletter: {
        mainCategory: 'eNewsletter',
        subCategories: [],
        isMainCategorySelected: false,
      },
      'Material Gallery': {
        mainCategory: 'Material Gallery',
        subCategories: [],
        isMainCategorySelected: false,
      },
      'Account Management': {
        mainCategory: 'Account Management',
        subCategories: [],
        isMainCategorySelected: false,
      },
    },
  }),
  watch: {
    selectedCategory: {
      handler(obj) {
        // console.log(obj);

        Object.keys(obj).forEach((category) => {
          const subCategoryLength = this.categoryOptions.find(
            (i) => i.mainCategory === category,
          ).subCategories.length;

          // 大類沒有次類時，才進行大類 checkbox 的狀態判斷
          if (subCategoryLength > 0) {
            // 若次類都打勾
            // 則大類自動打勾
            if (
              obj[category].isMainCategorySelected === false &&
              this.isAllSubCategoriesSelected(category)
            ) {
              this.selectedCategory[category].isMainCategorySelected = true;
              console.log(category);
            }
            // 若次類都沒打勾
            // 則大類自動不打勾
            if (
              obj[category].isMainCategorySelected === true &&
              this.isAllSubCategoriesNotSelected(category)
            ) {
              this.selectedCategory[category].isMainCategorySelected = false;
              console.log(category);
            }
            // 若次類部份打勾
            // 則大類 isMainCategorySelected 狀態改成 false
            if (this.isAllSubCategoriesSomeSelected(category)) {
              this.selectedCategory[category].isMainCategorySelected = false;
              console.log(category);
            }
          }
        });
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    cancelHandler() {
      this.$router.push('/account-list');
    },
    saveHandler() {
      this.$router.push('/account-list');
    },
    deleteHandler() {
      this.$router.push('/account-list');
    },
    checkAllSubCategories(mainCategory) {
      const { subCategories } = this.categoryOptions.find(
        (i) => i.mainCategory === mainCategory,
      );
      this.$set(
        this.selectedCategory[mainCategory],
        'subCategories',
        subCategories,
      );
    },
    uncheckAllSubCategories(mainCategory) {
      // const { subCategories } = this.categoryOptions.find(
      //   (i) => i.mainCategory === mainCategory,
      // );
      this.$set(this.selectedCategory[mainCategory], 'subCategories', []);
    },
    toggleAllSubcategoriesStatus(mainCategory) {
      if (this.selectedCategory[mainCategory].isMainCategorySelected) {
        this.checkAllSubCategories(mainCategory);
      } else {
        this.uncheckAllSubCategories(mainCategory);
      }
    },
    isAllSubCategoriesSelected(mainCategory) {
      const { subCategories } = this.categoryOptions.find(
        (i) => i.mainCategory === mainCategory,
      );
      const selectedSubCategories = this.selectedCategory[mainCategory]
        .subCategories;
      return subCategories.length === selectedSubCategories.length;
    },
    isAllSubCategoriesNotSelected(mainCategory) {
      const selectedSubCategories = this.selectedCategory[mainCategory]
        .subCategories;
      return selectedSubCategories.length === 0;
    },
    isAllSubCategoriesSomeSelected(mainCategory) {
      if (
        !this.isAllSubCategoriesSelected(mainCategory) &&
        !this.isAllSubCategoriesNotSelected(mainCategory)
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.col-main-category {
  width: 200px;
  margin-right: 20px;
}
</style>
